<div class="FilterModal">
  <div class="FilterBackdrop" (click)="closeModal()"></div>
  <div class="FilterDialog" (click)="$event.stopPropagation()">
    <button class="FilterClose" type="button" (click)="closeModal()">&times;</button>
    <h3>{{ title | t:title }}</h3>

    <form [formGroup]="form" (ngSubmit)="submit()">
      <div class="FilterFields">
        <div class="FilterField" [class.RadioFullRow]="field.type === 'radio' || field.type === 'switch'" *ngFor="let field of orderedFields">
          <ng-container *ngIf="field.type === 'text'">
            <label [for]="field.key">{{ field.label | t:field.label }}</label>
            <input
              [id]="field.key"
              type="text"
              [formControlName]="field.key"
              [placeholder]="(field.placeholder || '') | t:(field.placeholder || '')"
              (input)="onTextInput(field)"
            />
          </ng-container>

          <ng-container *ngIf="field.type === 'select'">
            <app-common-dropdown
              [compact]="true"
              [dropdownObj]="getDropdownObj(field)"
              [requestFilters]="getDropdownRequestFilters(field)"
              [value]="getFieldValue(field)"
              (optionsLoaded)="onDropdownOptionsLoaded(field, $event)"
              (valueChange)="onDropdownChange(field, $event)"
            ></app-common-dropdown>
          </ng-container>

          <ng-container *ngIf="field.type === 'radio'">
            <label>{{ field.label | t:field.label }}</label>
            <div class="RadioGroup">
              <label class="RadioItem" *ngFor="let option of (field.options || [])">
                <input
                  type="radio"
                  [formControlName]="field.key"
                  [value]="option.value"
                />
                <span>{{ option.label | t:option.label }}</span>
              </label>
            </div>
          </ng-container>

          <ng-container *ngIf="field.type === 'switch'">
            <label>{{ field.label | t:field.label }}</label>
            <label class="SwitchRow" [for]="field.key">
              <input
                class="SwitchInput"
                [id]="field.key"
                type="checkbox"
                [formControlName]="field.key"
              />
              <span class="SwitchTrack">
                <span class="SwitchThumb"></span>
              </span>
              <span class="SwitchText">{{ (field.switchLabel || 'common.showDeletedData') | t:(field.switchLabel || 'Show deleted data') }}</span>
            </label>
          </ng-container>

          <ng-container *ngIf="isDateRangeField(field)">
            <label>{{ field.label | t:field.label }}</label>
            <div class="DateRangePickerWrap" (click)="picker.open()">
              <mat-date-range-input [rangePicker]="picker" [separator]="''">
                <input
                  matStartDate
                  [formControlName]="field.key + '_start'"
                  [placeholder]="'common.startDate' | t:'Start date'"
                  readonly
                />
                <input
                  matEndDate
                  [formControlName]="field.key + '_end'"
                  [placeholder]="'common.endDate' | t:'End date'"
                  readonly
                />
              </mat-date-range-input>
              <mat-datepicker-toggle [for]="picker"></mat-datepicker-toggle>
              <mat-date-range-picker #picker></mat-date-range-picker>
            </div>
          </ng-container>
        </div>
      </div>

      <div class="FilterActions">
        <button class="ResetBTN" type="button" (click)="resetForm()">{{ 'common.reset' | t:'Reset' }}</button>
        <button class="PositiveBTN" type="submit">{{ 'common.apply' | t:'Apply' }}</button>
      </div>
    </form>
  </div>
</div>
